<script setup lang="ts">
import merge from 'lodash-es/merge';

defineOptions({
    name: 'ModuleGallerySettings'
});

const emit = defineEmits<{
    (e: 'update:modelValue', payload: any): void;
}>();

const props = defineProps<{
    modelValue: any;
}>();

const defaults = ref<any>({
    publishByUser: false,
    autoPublish: false
});

const form = computed<any>(() =>
{
    return props.modelValue;
});

watch(() => form.value.settings, () =>
{
    triggerModel();
},
{ deep: true });

watch(() => form.value.settings.publishByUser, (value: any) =>
{
    if (!value)
    {
        form.value.setings.autoPublish = false;
    }
},
{ deep: true });

function triggerModel(): void
{
    emit('update:modelValue', form.value);
}

onBeforeMount((): void =>
{
    form.value.settings = merge(defaults.value, form.value.settings);
});
</script>

<template>
    <IdeoFormGroup :invalid-feedback="form.$errors.first('settings.publishByUser')" :state="form.$errors.state('settings.publishByUser')">
        <IdeoFormCheckbox v-model="form.settings.publishByUser">
            {{ $t('[[[Publikacja galerii przez użytkownika]]]') }}
        </IdeoFormCheckbox>
    </IdeoFormGroup>
    <IdeoFormGroup v-if="form.settings.publishByUser" :invalid-feedback="form.$errors.first('settings.autoPublish')" :state="form.$errors.state('settings.autoPublish')">
        <IdeoFormCheckbox v-model="form.settings.autoPublish">
            {{ $t('[[[Automatyczna publikacja galerii]]]') }}
        </IdeoFormCheckbox>
    </IdeoFormGroup>
</template>
